import { useState } from "react";
import { Mail, MapPin, Phone, Send } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Message sent. We'll reply within 1 working day.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  return (
    <div data-testid="contact-page" className="min-h-screen">
      <section className="border-b-[3px] border-black">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
          <div className="font-mono-ui text-xs text-[#ff1493]">— GET IN TOUCH</div>
          <h1 className="font-display text-5xl md:text-6xl leading-none mt-3">Contact</h1>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 md:px-8 py-14 grid lg:grid-cols-5 gap-10">
        <div className="lg:col-span-2 space-y-5">
          <div className="border-[3px] border-black bg-white p-5 shadow-brut-sm flex items-start gap-4">
            <Mail className="w-5 h-5 text-[#ff1493] mt-1" strokeWidth={2.5} />
            <div>
              <div className="font-mono-ui text-[11px] text-black/60">EMAIL</div>
              <a className="font-display text-lg" href="mailto:hello@ukpeptideresearch.com">hello@ukpeptideresearch.com</a>
            </div>
          </div>
          <div className="border-[3px] border-black bg-white p-5 shadow-brut-sm flex items-start gap-4">
            <Phone className="w-5 h-5 text-[#00d4ff] mt-1" strokeWidth={2.5} />
            <div>
              <div className="font-mono-ui text-[11px] text-black/60">PHONE</div>
              <div className="font-display text-lg">+44 141 000 0000</div>
            </div>
          </div>
          <div className="border-[3px] border-black bg-white p-5 shadow-brut-sm flex items-start gap-4">
            <MapPin className="w-5 h-5 text-black mt-1" strokeWidth={2.5} />
            <div>
              <div className="font-mono-ui text-[11px] text-black/60">LAB</div>
              <div className="font-display text-lg">Glasgow, UK</div>
              <div className="font-mono-ui text-[11px] text-black/60 mt-1">Visits by appointment only</div>
            </div>
          </div>
        </div>

        <form onSubmit={onSubmit} className="lg:col-span-3 border-[3px] border-black bg-white p-6 md:p-8 shadow-brut space-y-4">
          <div className="font-display text-2xl">Send a message</div>
          <div className="grid sm:grid-cols-2 gap-4">
            <div>
              <label className="font-mono-ui text-[10px] block mb-1">NAME</label>
              <input required value={form.name} onChange={upd("name")} data-testid="contact-name" className="w-full border-[3px] border-black px-3 py-2 font-mono-ui text-xs focus:outline-none" />
            </div>
            <div>
              <label className="font-mono-ui text-[10px] block mb-1">EMAIL</label>
              <input type="email" required value={form.email} onChange={upd("email")} data-testid="contact-email" className="w-full border-[3px] border-black px-3 py-2 font-mono-ui text-xs focus:outline-none" />
            </div>
          </div>
          <div>
            <label className="font-mono-ui text-[10px] block mb-1">SUBJECT</label>
            <input required value={form.subject} onChange={upd("subject")} data-testid="contact-subject" className="w-full border-[3px] border-black px-3 py-2 font-mono-ui text-xs focus:outline-none" />
          </div>
          <div>
            <label className="font-mono-ui text-[10px] block mb-1">MESSAGE</label>
            <textarea required rows={6} value={form.message} onChange={upd("message")} data-testid="contact-message" className="w-full border-[3px] border-black px-3 py-2 font-mono-ui text-xs focus:outline-none resize-none" />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="contact-submit"
            className="inline-flex items-center gap-2 px-6 py-3 bg-[#ff1493] text-white border-[3px] border-black shadow-brut btn-press font-mono-ui text-xs font-bold disabled:opacity-60"
          >
            <Send className="w-4 h-4" /> {loading ? "SENDING…" : "SEND MESSAGE"}
          </button>
        </form>
      </section>
    </div>
  );
}
